import {
  FETCH_TAG,
  FETCH_TAGS
} from "../actions/actionTypes";

const DEFAULT_STATE = {
  tags: [],
  tag: {}
};

export default (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_TAGS:
      return {...state, tags: action.payload};
    case FETCH_TAG:
      return {...state, tag: action.payload};
    default:
      return state;
  }
}